import { render, staticRenderFns } from "./WhitelistedDeviceList.vue?vue&type=template&id=15dd8518&scoped=true"
import script from "./WhitelistedDeviceList.vue?vue&type=script&lang=js"
export * from "./WhitelistedDeviceList.vue?vue&type=script&lang=js"
import style0 from "./WhitelistedDeviceList.vue?vue&type=style&index=0&id=15dd8518&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dd8518",
  null
  
)

export default component.exports